import styled from 'styled-components';

export const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;

	label {
		font-size: 12px;
		font-weight: 500;
		color: #666;
		margin-bottom: 4px;
	}
`;

export const DateInput = styled.div`
	display: flex;
	align-items: center;
	padding: 10px 12px;
	border: 1px solid #e0e0e0;
	border-radius: 6px;
	background-color: #fff;
	cursor: pointer;
	font-size: 14px;
	color: #333;
	transition: all 0.2s ease;
	min-height: 20px;

	&:hover {
		border-color: #007bff;
		box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
	}

	&:focus {
		outline: none;
		border-color: #007bff;
		box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
	}
`;

export const Dropdown = styled.div`
	position: fixed;
	top: auto;
	left: auto;
	margin-top: 4px;
	z-index: 99999;
	background: #fff;
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
	overflow: hidden;
	transform: translateY(0);
`;

export const Calendar = styled.div`
	padding: 16px;
	min-width: 280px;
`;

export const DateButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border: none;
	background: ${props => {
		if ( props.$isSelected ) return '#007bff';
		if ( props.$isInRange ) return '#e3f2fd';
		return 'transparent';
	}};
	color: ${props => {
		if ( props.$isSelected ) return '#fff';
		if ( !props.$isCurrentMonth ) return '#ccc';
		return '#333';
	}};
	border-radius: 4px;
	cursor: ${props => props.$isCurrentMonth ? 'pointer' : 'default'};
	font-size: 14px;
	font-weight: ${props => props.$isSelected ? '600' : '400'};
	transition: all 0.2s ease;

	&:hover {
		background-color: ${props => {
		if ( props.$isSelected ) return '#0056b3';
		if ( props.$isCurrentMonth ) return '#f0f0f0';
		return 'transparent';
	}};
	}

	&:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}
`; 